/* StillLife 下層ページ（index 以外の全テンプレート）の共通スクリプト。
 * 1つ目のブロック = 共通ヘッダーのメニュー開閉（出典: static/js/script.js のメニュー開閉相当）
 * 2つ目のブロック = カート追加のフィードバック（#31）
 * 3つ目のブロック = 開いているカートドロワーの小計再同期（#34）
 * TOPの横スクロール処理には関与しない。読み込みは layout/theme.liquid の sl_is_subpage 分岐。 */
(function () {
  var header = document.querySelector('[data-sl-header]');
  if (!header) return;

  var toggle = header.querySelector('[data-sl-menu-toggle]');
  var overlay = header.querySelector('[data-sl-menu-close]');
  var drawer = header.querySelector('[data-sl-menu-drawer]');
  if (!toggle || !drawer) return;

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  // 段送りの対象。TOP の drawerRevealTargets と同じ考え方（#89）
  var revealTargets = Array.prototype.slice.call(
    drawer.querySelectorAll('.sl-header__menu-item')
  );

  // 初期状態（隠れている側）は読み込み時に付ける。開くときに2つのクラスを
  // 同じフレームで付けると、隠れている状態が描画されずトランジションが走らない。
  // JSが動かない環境では付かないので、その場合は最初から全項目が見える（#89）
  revealTargets.forEach(function (el) {
    el.classList.add('sl-reveal-item');
  });

  function playReveal() {
    // 再生し直すためにスタイルを一度フラッシュする（TOP と同じ）
    void drawer.offsetWidth;

    revealTargets.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function resetReveal() {
    revealTargets.forEach(function (el) {
      el.classList.remove('is-visible');
    });
  }

  function focusables() {
    return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function setOpen(open) {
    header.classList.toggle('sl-header--open', open);
    toggle.setAttribute('aria-expanded', String(open));

    // 開いている間は背後をスクロールさせない（TOP と同じ・#89）。
    // position: fixed を使わないので、閉じたときのスクロール位置はそのまま残る
    document.body.style.overflow = open ? 'hidden' : '';

    if (open) {
      playReveal();
    } else {
      resetReveal();
    }

    // 閉じている間はドロワー内をタブ移動・支援技術から到達不可にする
    drawer.setAttribute('aria-hidden', String(!open));
    if (open) {
      drawer.removeAttribute('inert');
    } else {
      drawer.setAttribute('inert', '');
    }
    if (open) {
      var first = focusables()[0];
      if (first) first.focus();
    } else {
      toggle.focus();
    }
  }

  toggle.addEventListener('click', function () {
    setOpen(!header.classList.contains('sl-header--open'));
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      setOpen(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!header.classList.contains('sl-header--open')) return;

    if (event.key === 'Escape') {
      setOpen(false);
      return;
    }

    // ドロワーを開いている間はフォーカスをドロワー内に閉じ込める
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    if (event.shiftKey && (active === first || !drawer.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !drawer.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  });
})();

/* カートドロワーを開いたまま商品を追加したときの小計再同期（#34）。
 * Pipeline は追加直後に theme:cart:reload を先に投げ、その後 cart.js の取得完了時に
 * theme:cart:change を投げる。この順序では最初の reload が古い this.cart で小計を描画する。
 * 「開いたドロワーで reload が先行した」場合だけ待機し、次の cart:change 後に1回だけ
 * reload し直す。数量変更は reload を先行させないため、この処理には入らない。 */
(function () {
  var CART_DRAWER = '[data-drawer="drawer-cart"]';
  var DRAWER_VISIBLE = 'drawer--visible';
  var OWN_RELOAD_FLAG = 'stilllifeFreshCart';
  var ADD_SUBMIT_TIMEOUT = 5000;
  var addSubmittedWhileOpen = false;
  var awaitingFreshCart = false;
  var addSubmitTimer = null;

  function drawerIsOpen() {
    var drawer = document.querySelector(CART_DRAWER);
    return !!(
      drawer &&
      drawer.classList.contains(DRAWER_VISIBLE) &&
      window.theme &&
      window.theme.state &&
      window.theme.state.cartOpen
    );
  }

  function resetAddSubmit() {
    clearTimeout(addSubmitTimer);
    addSubmitTimer = null;
    addSubmittedWhileOpen = false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.shopify-product-form, form[action$="/cart/add"]')) return;
    if (!drawerIsOpen()) return;

    addSubmittedWhileOpen = true;
    clearTimeout(addSubmitTimer);
    addSubmitTimer = setTimeout(resetAddSubmit, ADD_SUBMIT_TIMEOUT);
  }, true);

  document.addEventListener('theme:cart:reload', function (event) {
    if (event.detail && event.detail[OWN_RELOAD_FLAG]) return;
    if (!addSubmittedWhileOpen || !drawerIsOpen()) return;

    resetAddSubmit();
    awaitingFreshCart = true;
  });

  document.addEventListener('theme:cart:change', function () {
    if (!awaitingFreshCart) return;
    awaitingFreshCart = false;

    document.dispatchEvent(new CustomEvent('theme:cart:reload', {
      detail: { stilllifeFreshCart: true },
      bubbles: true
    }));
  });
})();

/* カート追加のフィードバック（#31）。
 * Pipeline の確認ポップダウン（CartPopdown）は register('header', ...) 配下にしか登録されておらず、
 * 下層ページでは受け皿の div を置いてもポップダウン自体を描画できない。
 * そこで CartPopdown と同じ分岐（theme.js の CartPopdown コンストラクタ）を再実装し、
 * カートページではカートを取り直し、それ以外ではカートドロワーを開いてフィードバックにする。
 * 受け皿の [data-product-add-popdown-wrapper] は stilllife-header.liquid にある。 */
(function () {
  // Pipeline 内部の名前に依存している。テーマ更新で変わっても例外は出ず無音になるため、
  // 見つからないケースでは console.warn を出して検知できるようにしている。
  var CART_DRAWER = '[data-drawer="drawer-cart"]';
  var CART_AJAX = '[data-section-type="cart"]:not([data-ajax-disable="true"])';
  var CART_NO_AJAX = '[data-section-type="cart"][data-ajax-disable="true"]';
  var DRAWER_VISIBLE = 'drawer--visible';

  // theme:cart:change（cart.js の取得完了）を待つ上限。実測では popdown の 188ms 後に届くので、
  // 通信が遅いときの保険として十分に長い値を置いている。
  var FALLBACK_DELAY = 1500;
  // 上限を過ぎて先に出したあと、遅れて届く cart:change を受け付ける猶予。
  // ここで必ず待ち受けを終わらせる（放置すると無関係な cart:change でドロワーが開く）
  var GRACE_DELAY = 3000;

  var waiting = false;
  var waitTimer = null;
  var graceTimer = null;

  function showFeedback() {
    // 以下2つはカートページ用の分岐。Pipeline の CartPopdown と同じ振る舞いにしている。
    // 下層ヘッダーを使う構成では CartPopdown が居ないので、ここで肩代わりしないと
    // カートページのアップセル（api-product-quickview の productForm）が無反応になる
    var cartAjax = document.querySelector(CART_AJAX);
    if (cartAjax) {
      cartAjax.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      return;
    }
    if (document.querySelector(CART_NO_AJAX)) {
      window.location.reload();
      return;
    }

    var drawer = document.querySelector(CART_DRAWER);
    if (!drawer) {
      // settings.cart_style が drawer / pop 以外だとドロワー自体が出力されない
      // （sections/cart-drawer.liquid）。無音にすると #31 の症状に戻るのでカートページへ送る
      console.warn('[stilllife] ' + CART_DRAWER + ' が無いためカートページへ遷移します（settings.cart_style を確認）');
      window.location.href = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
      return;
    }

    if (drawer.classList.contains(DRAWER_VISIBLE)) {
      // 開いている最中は開き直さず中身だけ取り直す（CartItems が theme:cart:reload を受ける）
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    } else {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }
  }

  function stopWaiting() {
    document.removeEventListener('theme:cart:change', onCartChange);
    clearTimeout(waitTimer);
    clearTimeout(graceTimer);
    waitTimer = null;
    graceTimer = null;
    waiting = false;
  }

  function onCartChange() {
    stopWaiting();
    showFeedback();
  }

  function onTimeout() {
    // cart.js が遅い・失敗しても動線を止めない。先に出しておき、
    // 遅れて cart:change が届いたら onCartChange が中身を取り直す。
    // ただし GRACE_DELAY で待ち受けを打ち切る（リスナーを残したままにしない）
    waitTimer = null;
    showFeedback();
    graceTimer = setTimeout(stopWaiting, GRACE_DELAY);
  }

  document.addEventListener('theme:cart:popdown', function (event) {
    // Pipeline の openPopdown() は必ず variant を積む。他スクリプト由来の同名イベントは無視する
    if (!event.detail || !event.detail.variant) return;

    // Pipeline の CartItems は theme:cart:change で stale を立ててから loadHTML() で描き直す。
    // popdown の時点ではまだ cart.js が返っておらず、先に開くと2回目以降の追加で
    // 1つ前のカートと小計が出る。そのため cart:change を待ってからフィードバックを出す。
    // CartItems 側のリスナーはページ初期化時に登録済みで、こちらはクリック時に登録するため、
    // 同じ theme:cart:change では必ず CartItems が先に走る（登録順に依存している）。
    if (waiting) {
      // 連続追加。最後の追加を反映させたいので待ち直す
      clearTimeout(waitTimer);
      clearTimeout(graceTimer);
      graceTimer = null;
    } else {
      document.addEventListener('theme:cart:change', onCartChange);
      waiting = true;
    }

    waitTimer = setTimeout(onTimeout, FALLBACK_DELAY);
  });
})();
